import { useMember } from './useMember';
import { MemberTable } from './MemberTable';
import { InviteUserModal } from 'ui/components/screens/modals/InviteUserModal/InviteUserModal';
import { SnackBar } from 'ui/components/elements/SnackBar/SnackBar';
import { NeedProfileRegistration } from 'ui/components/company/screens/modals/NeedProfileRegistration/NeedProfileRegistration';

export const MemberList: React.FC = () => {
    const {
        memberList,
        showSnackbar,
        inviteModal,
        needProfileModal,
        errors,
        inviting,
        setShowSnackbar,
        setValue,
        invite,
    } = useMember();
    const { openModal, createModal } = inviteModal;
    const { openModal: openNeedProfileModal, createModal: createNeedProfileModal } = needProfileModal;

    return (
        <>
            <SnackBar message="招待メールを送信しました" open={showSnackbar} setOpen={setShowSnackbar} />
            {createModal(
                <InviteUserModal
                    onClick={invite}
                    setValue={(value) => setValue('email', value)}
                    errorMsg={errors.email?.message || ''}
                    disabled={inviting}
                />,
            )}
            {createNeedProfileModal(<NeedProfileRegistration />)}
            <MemberTable openModal={openModal} openNeedProfileModal={openNeedProfileModal} memberList={memberList} />
        </>
    );
};
